import { EndpointConfig } from '@core/store/apiRequest/declarations'

export const getLegacyPeopleGroupByClub: EndpointConfig = {
  storeKey: 'getLegacyPeopleGroupByClub',
  url: '/api/people-group-by-club',
}
